import React, {FC} from "react";
import {useNavigate} from "react-router-dom";
import Badge from "shared/Badge/Badge";
import {EventType} from "data/types";
import NcImage from "shared/NcImage/NcImage";
import {convertServerDateToLocalDateShort} from "../../utils/convertServerDateToLocalDate";

export interface PropertyCardHProps {
  className?: string;
  data: EventType;
}

const EventShopCard: FC<PropertyCardHProps> = ({className = "", data}) => {
  const navigate = useNavigate();
  const eventDate = convertServerDateToLocalDateShort(data.startTime);

  const handleNavigate = () => {
    localStorage.setItem("eventSelected", JSON.stringify(data));
    let dataEvent = {
      event: data._id,
      lat: data.lat,
      lng: data.lng,
    };
    let encodeRaceId = btoa(JSON.stringify(dataEvent));

    navigate(`/detailEvent/${encodeRaceId}`, {state: data}); // Aquí defines la ruta a la que quieres navegar
  };
  const renderSliderGallery = () => {
    return (
      <div className="flex-shrink-0 p-3 w-full sm:w-64 ">
        {/* <GallerySlider
          ratioClass="aspect-w-1 aspect-h-1"
          galleryImgs={[data.img]}
          className="w-full h-full rounded-2xl overflow-hidden will-change-transform"
          uniqueID={`PropertyCardH_${data?._id}`}
          // href={''}
        /> */}
        <NcImage
          containerClassName={`flex-shrink-0 rounded-3xl mr-4 aspect-w-1 aspect-h-1 w-full h-full rounded-2xl overflow-hidden will-change-transform`}
          src={data.img}
        />

        {/* {saleOff && (
          <SaleOffBadge className="absolute left-5 top-5 !bg-orange-500" />
        )} */}
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <div className="inline-grid grid-cols-1 gap-2">
        {data.category !== "Sorteo" && (
          <div className="flex items-center space-x-2">
            <span className="hidden sm:inline-block">
              <i className="las la-map-marker text-lg"></i>
            </span>
            <span className="text-xs text-neutral-500 dark:text-neutral-400">
              {data?.place}
            </span>
          </div>
        )}
        {/* ---- */}
        {/* <div className="flex items-center space-x-2">
          <span className="hidden sm:inline-block">
            <i className="las la-bath text-lg"></i>
          </span>
          <span className="text-xs text-neutral-500 dark:text-neutral-400">
            3 baths
          </span>
        </div> */}
        {/* ---- */}
        <div className="flex items-center space-x-2">
          <span className="hidden sm:inline-block">
            <i className="las la-info text-lg"></i>
          </span>
          <span
            className="text-xs text-neutral-500 dark:text-neutral-400 overflow-hidden whitespace-nowrap text-ellipsis"
            title={data.description}
          >
            {data.description?.length > 100
              ? data.description.substring(0, 100) + "..."
              : data.description}
          </span>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="flex-grow p-3 sm:pr-6 flex flex-col items-start">
        <div className="space-y-4 w-full">
          <div className="inline-flex space-x-3">
            <Badge
              name={
                <div className="flex items-center">
                  <i className="text-sm las la-tag"></i>
                  <span className="ml-1">{data.category}</span>
                </div>
              }
            />
            {data.category !== "Sorteo" && (
              <Badge
                name={
                  <div className="flex items-center">
                    <i className="text-sm las la-city"></i>
                    <span className="ml-1">{data.city?.description}</span>
                  </div>
                }
                color="yellow"
              />
            )}
          </div>
          <div className="flex items-center space-x-2">
            {/* {isAds && <Badge name="ADS" color="green" />} */}
            <h2 className="text-lg font-medium capitalize">
              <span className="line-clamp-2">{data?.nameEvent}</span>
            </h2>
          </div>
          {renderTienIch()}
          <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 "></div>
          <div className="flex w-full justify-between items-end">
            <div className="flex items-center space-x-2">
              {data.category !== "Sorteo" && (
                <>
                  <span className="hidden sm:inline-block">
                    <i className="las la-calendar text-lg"></i>
                  </span>
                  <span className="text-xs text-neutral-500 dark:text-neutral-400">
                    {eventDate.customDate}
                  </span>
                </>
              )}
            </div>

            <div className="flex flex-col items-center">
              <span className="text-xs text-neutral-500 dark:text-neutral-400">
                Desde
              </span>
              <span className="flex items-center justify-center px-3 py-2 border border-secondary-500 rounded-xl leading-none text-base font-medium text-secondary-500">
                {`$${data.localitiesFrom}`}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-PropertyCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl hover:shadow-2xl transition-shadow ${className}`}
      data-nc-id="PropertyCardH"
      onClick={handleNavigate}
    >
      {/* <Link to={'/'} className="absolute inset-0"></Link> */}
      <div className="h-full w-full flex flex-col sm:flex-row sm:items-center cursor-pointer">
        {renderSliderGallery()}
        {renderContent()}
      </div>
      {/* <BtnLikeIcon
        colorClass={` bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 hover:bg-opacity-70 text-neutral-6000 dark:text-neutral-400`}
        isLiked={like}
        className="absolute right-5 top-5 sm:right-3 sm:top-3 "
      /> */}
    </div>
  );
};

export default EventShopCard;
